import './banner.css'

const Banner = () => {
    return (<header className="cabecalho">
        <img src='/imagens/banner3.png' alt='Logo do Organo'/>
    </header>)
}

export default Banner